import { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import CircularProgress from '@mui/material/CircularProgress'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'

import LoadingBox from "@/components/loading-box"
import ErrorBox from "@/components/error-box"
import { ExportStatus } from '@/types'
import { useGenerateFeePayersStatus } from '@/hooks/api/use-yearly-fee-collection'

function FeePayersGenerationStatus({
    jobId,
    handleClose,
}: {
    jobId: number,
    handleClose: () => void,
}) {

    const [keepRefetching, setKeepRefetching] = useState<boolean>(true)
    
    const { status, data, error } = useGenerateFeePayersStatus(jobId, keepRefetching)

    useEffect(() => {
        if (data?.state === ExportStatus.successful || data?.state === ExportStatus.failed) {
            setKeepRefetching(false)
        }
    }, [data])

    if (status === 'pending') {
        return (
            <LoadingBox />
        )
    }

    if (error) {
        return <ErrorBox
            error={error}
            message={`Nepovedlo se načíst status s ID ${jobId}`}
        />
    }

    return (
        <Box sx={{
            flexGrow: 1,
            width: '100%',
            pb: 0.5,
        }}>
            {data.state === ExportStatus.processing &&
                <Alert
                    severity="info"
                    icon={<CircularProgress size={20} color="inherit" />}
                >
                    Generuji poplatníky z databáze svozových míst. Tato operace může trvat až několik minut.
                </Alert>
            }
            {data.state === ExportStatus.successful &&
                <Alert
                    severity="success"
                    action={
                        <Box sx={{
                            display: 'flex',
                            gap: 1,
                            flexWrap: 'wrap',
                        }}>
                            <IconButton
                                color="inherit"
                                size="small"
                                onClick={() => handleClose()}
                            >
                                <CloseRoundedIcon />
                            </IconButton>
                        </Box>
                    }
                >
                    Generování plátců úspěšně dokončeno.
                </Alert>
            }
            {data.state === ExportStatus.failed &&
                <Alert
                    severity="error"
                    action={
                        <Button
                            color="inherit"
                            size="small"
                            onClick={() => handleClose()}
                        >
                            Zavřít
                        </Button>
                    }
                >
                    Generování plátců se nepodařilo dokončit.
                </Alert>
            }
        </Box>
    )
}

export default FeePayersGenerationStatus
